import React, { Component } from 'react';
import { Modal, Button } from 'semantic-ui-react';

class ResendModal extends Component {

  render() {

    const { open, cancel, confirm } = this.props.modalFn;


    return(
      <Modal
        className="modal-small"
        open={open}
        onClose={cancel}>

        <Modal.Content>
          회원가입 요청 내역을 재전송 하시겠습니까?
        </Modal.Content>

        <Modal.Actions>
          <Button
            inverted color='grey'
            onClick={cancel}
            content="취소" />
          <Button
            positive
            onClick={confirm}
            content="확인" />
        </Modal.Actions>

      </Modal>
    );
  }

}

export default ResendModal;
